export {default as ValitseTiedonkeruu} from './ValitseTiedonkeruu';
